import type { WithActiveBranchId } from '@app/api/shared';
import type { IBaseQueryParams } from '@app/services/rtkQuery/baseQuery';

import type { BranchJournalTimeFormat } from '../Branches/types';

export enum SettingsEndpoints {
  // Настройки журнала записей читаются и сохраняются одним путём: GET отдаёт
  // модель, POST её же принимает (us/11144, комментарий Соболева 16.09.2026).
  // Прежние GetBranchJournalTimeFormat / SetBranchJournalTimeFormat с бэка
  // удалены.
  GetJournalSettings = 'GetJournalSettings',
  GetLeadsFreeOwnerTimeout = 'Leads/GetLeadsFreeOwnerTimeout',
  SetLeadsFreeOwnerTimeout = 'Leads/SetLeadsFreeOwnerTimeout',
}

export interface ModelSelectItem {
  Id: number;
  Key: string | null;
  Value: string | null;
  IsSelected: boolean;
}

export interface TimeFormatSelectItem extends ModelSelectItem {
  Key: BranchJournalTimeFormat;
}

export interface ModelLeadsFreeOwnerTimeout {
  Value: number | null;
  Never?: boolean;
}

type WithOptionalActiveBranchId<T = {}> = T & Partial<WithActiveBranchId>;

export interface ModelJournalSettings {
  BranchId: number;
  // Показывать ли окно тегов после сохранения новой записи (ТЗ us/11144, п.6).
  IsRecordTagsWindow: boolean;
  TimeFormat: BranchJournalTimeFormat | null;
  TimeFormats: TimeFormatSelectItem[] | null;
}

export type GetJournalSettingsRequest = WithOptionalActiveBranchId<{
  logs?: IBaseQueryParams['logs'];
}>;

export type GetJournalSettingsResponse = ModelJournalSettings;

export type SetJournalSettingsRequest = WithOptionalActiveBranchId<{
  data: ModelJournalSettings;
}>;

export type SetJournalSettingsResponse = ModelJournalSettings;

export type GetLeadsFreeOwnerTimeoutRequest = WithActiveBranchId;

export type SetLeadsFreeOwnerTimeoutRequest = WithActiveBranchId<{
  Value: number | null;
}>;

export type GetLeadsFreeOwnerTimeoutResponse = ModelLeadsFreeOwnerTimeout;

export type SetLeadsFreeOwnerTimeoutResponse = ModelLeadsFreeOwnerTimeout;
